// extracted by mini-css-extract-plugin
export default {"navigation":"NavigationBar_navigation__H-0Ia","main_link":"NavigationBar_main_link__kSVrj","page_name":"NavigationBar_page_name__+vt8b"};